import { DjangoTimeStamped, TimeStamped } from '../django';
import { applyTimezone, parseDate } from '../helpers/date';
import { EMPLOYEE_DATA_FILE_HISTORY_STATUS } from './data-file-history-status/enum';

export class EmployeeDataFileHistory implements TimeStamped {
  fileName: string;
  filePath: string;
  uploaderUserId: string;
  uploaderEmail: string;
  status: EMPLOYEE_DATA_FILE_HISTORY_STATUS;
  created: Date;
  modified: Date;

  constructor(data: EmployeeDataFileHistory | DjangoEmployeeDataFileHistory) {
    bindConstructorDataToInstance(this, data);
  }
}

function bindConstructorDataToInstance(
  instance: EmployeeDataFileHistory,
  data: EmployeeDataFileHistory | DjangoEmployeeDataFileHistory,
) {
  const jsData = bindDjangoPropsToJs(data);
  instance.fileName = jsData.fileName;
  instance.filePath = jsData.filePath;
  instance.uploaderUserId = jsData.uploaderUserId;
  instance.uploaderEmail = jsData.uploaderEmail;
  instance.created = applyTimezone(parseDate(jsData.created), 0);
  instance.modified = applyTimezone(parseDate(jsData.modified), 0);
}

function bindDjangoPropsToJs(data: EmployeeDataFileHistory | DjangoEmployeeDataFileHistory) {
  const djangoData = data as DjangoEmployeeDataFileHistory;
  const jsData = data as EmployeeDataFileHistory;
  return {
    fileName: djangoData.file_name || jsData.fileName,
    filePath: djangoData.file_path || jsData.filePath,
    uploaderUserId: djangoData.uploader_user_id || jsData.uploaderUserId,
    uploaderEmail: djangoData.uploader_email || jsData.uploaderEmail,
    created: djangoData.created || jsData.created,
    modified: djangoData.modified || jsData.modified,
  };
}

export interface DjangoEmployeeDataFileHistory extends DjangoTimeStamped {
  file_name: string;
  file_path: string;
  uploader_user_id: string;
  uploader_email: string;
  status: EMPLOYEE_DATA_FILE_HISTORY_STATUS;
  created?: string;
  modified?: string;
}
